import React, { FC } from 'react';

import { DragIcon } from '@adsk/alloy-react-icon';
import { StylableComponent, stylePropType } from '@adsk/alloy-react-theme';

type DragHandleProps = StylableComponent<HTMLDivElement> & {
  disabled?: boolean;
};

const DragHandle: FC<DragHandleProps> = ({ disabled, style, ...props }) => (
  <div css={[{ display: 'flex', alignItems: 'center' }, style]} {...props}>
    <DragIcon style={{ marginRight: 8 }} />
  </div>
);

DragHandle.propTypes = {
  style: stylePropType,
};

export default DragHandle;
